import React, { useCallback, useEffect, useReducer, useRef, useState } from 'react';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import api from '../../apiSingleton';
import Spinner from '../Spinner';
import { useModal } from '../../utils/useModal';
import ClosePopupIcon from '../../assets/icon/ClosePopupIcon';
import style from '../PopupLogIn/PopupLogIn.module.scss';

function PopupRecoveryPassword() {
    const email = useRef();
    const [ loading, setLoading ] = useState(false);
    const popupBody = useRef(null);
    const popup = useRef();
    const { dismiss } = useModal();
    const [ initPopup, setInitPopup ] = useState(false);
    const [ change, setChange ] = useState(false);
    const [ error, setError ] = useState('');
    const [ emailSent, setEmailSent ] = useState(false);

    const [ event, updateEvent ] = useReducer(
        (prev, next) => ({ ...prev, ...next }),
        { email: '' }
    );

    useEffect(() => {
        document.addEventListener('click', closeModal);
        setInitPopup(true);
        disableBodyScroll(document.body);

        return () => document.removeEventListener('click', closeModal);
    }, []);

    const closeModal = useCallback(({ target }) => {
        if (popupBody?.current && !popupBody?.current.contains(target)) {
            enableBodyScroll(document.body);
            clearAllBodyScrollLocks();
            dismiss();
        }
    }, [ popupBody ]);


    const validateEmail = useCallback((eml) => {
        const re = /\S+@\S+\.\S+/;

        return re.test(eml);
    }, []);

    const closeBtn = useCallback((delay = 0) => {
        setTimeout(() => {
            dismiss();
            enableBodyScroll(document.body);
        }, delay);
    }, [ dismiss ]);

    const requestForm = useCallback(async (e) => {
        e.preventDefault();

        if (!validateEmail(event.email)) {
            setChange(true);

            return;
        }

        if (change) setChange(false);

        setLoading(true);

        try {
            await api.authenticate.resetPasswordEmail(event);
            setLoading(false);
            setEmailSent(true);
            closeBtn(2000); // Close after 2 seconds
        } catch ({ errors }) {
            setError(errors?.message);
            setLoading(false);
        }
    }, [ event, closeBtn ]);

    const changeHandle = useCallback(({ target })  => {
        setError('');
        setChange(false);
        updateEvent({ [target.name]: target.value });
    }, []);

    return (
        <>
            <CSSTransition
                timeout={300}
                in={initPopup}
                unmountOnExit
                classNames='item'
                mode={'out-in'}
            >
                <section className={style['popup-login']}  ref={popup}>
                    <div className={style['popup-login__wrapper']} ref={popupBody}>
                        <button className={style['popup-login__close']} onClick={closeBtn}>
                            <ClosePopupIcon />
                        </button>

                        { loading &&  <Spinner /> }
                        <h2>{emailSent ? 'Лист відправлено' : 'Відновлення паролю'}</h2>

                        {emailSent ? (
                            <div className={style['success-message']}>
                                <p>Перевірте вашу пошту для подальших інструкцій</p>
                            </div>
                        ) : (
                            <form onSubmit={requestForm}>
                                <label>
                                    <input
                                        ref={email}
                                        name={'email'}
                                        type='text'
                                        placeholder={'Введіть Email'}
                                        onChange={changeHandle}
                                    />
                                    {
                                        (change && !validateEmail(event.email)) && <span>Enter correct email</span>
                                    }
                                </label>
                                <button className={classNames({ [style.error]: error?.length > 0 })}>
                                    Відправити лист
                                </button>
                            </form>
                        )}
                    </div>
                </section>
            </CSSTransition>
        </>
    );
}

export default React.memo(PopupRecoveryPassword);
